import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getModeList = store => store[NAME].modeList;
export const getFrequencyList = store => store[NAME].frequencyList;
export const getConceptList = store => store[NAME].conceptList;